import React from 'react';
import { Image } from 'react-bootstrap';
import RelatedProductsCSS from './relatedProducts.module.css';
import CustomButton from '../customButton';
import { Link } from 'react-router-dom';
import defaultLogo from '../../images/Logo.png';

const RelatedProducts = ({ relatedProducts }) => {
    // console.log(relatedProducts);
    const supplierName = relatedProducts.data.supplier.data.attributes.name;

    const products = relatedProducts.data.supplier.data.attributes.products.data;


    return(
        <div className={RelatedProductsCSS.Container}>
            <h2>Mer fra {supplierName}!</h2>
            <div className={RelatedProductsCSS.container2}>
                {products.map((product) => {
                     const imageUrl = product.attributes?.image?.data?.attributes?.url || defaultLogo;
                     return(
                    <div className={RelatedProductsCSS.Card} key={product.id}>
                        <Link to={`/product/${product.id}`}>
                        <div className={RelatedProductsCSS.ImageContainer}>
                            <Image fluid alt={product.attributes.name} src={imageUrl} />
                        </div>
                        <p className={RelatedProductsCSS.cardName}>{product.attributes.name}</p>
                        <CustomButton 
                            label="Se mer"
                            className={RelatedProductsCSS.button}
                        />
                        </Link>
                    </div>
                     )
                })}
            </div>
        </div>
    )
}

export default RelatedProducts;